import { LOAD_USER_PROFILE, LOAD_USER_PROFILE_SUCCESS } from './constants';
import config from '~/config';
import { localStorage } from '~/services';

export const initialState = {
  profile: {
    role: config.defaultRole,
    isAuthenticated: false,
  },
};

function authReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_USER_PROFILE_SUCCESS:
    if (process.browser) {
      localStorage.userProfile = action.payload;
    }
    return { ...state, profile: action.payload };
  default:
    return state;
  }
}

export default authReducer;
